import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18fbbd33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-outline" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "启用边框：", -1))
const _hoisted_4 = {
  class: "switch-wrapper",
  style: {"width":"60%"}
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "边框样式：", -1))
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "边框颜色：", -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "边框粗细：", -1))

import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import type { PPTElementOutline } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import ColorButton from './ColorButton.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import Switch from '@/components/Switch.vue'
import NumberInput from '@/components/NumberInput.vue'
import Select from '@/components/Select.vue'
import Popover from '@/components/Popover.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ElementOutline',
  props: {
    fixed: { type: Boolean, default: false }
  },
  setup(__props: any) {



const slidesStore = useSlidesStore()
const { theme } = storeToRefs(slidesStore)
const { handleElement } = storeToRefs(useMainStore())

const outline = ref<PPTElementOutline>()
const hasOutline = ref(false)

watch(handleElement, () => {
  if (!handleElement.value) return
  outline.value = 'outline' in handleElement.value ? handleElement.value.outline : undefined
  hasOutline.value = !!outline.value
}, { deep: true, immediate: true })

const { addHistorySnapshot } = useHistorySnapshot()

const updateOutline = (outlineProps: Partial<PPTElementOutline>) => {
  if (!handleElement.value) return
  const props = { outline: { ...outline.value, ...outlineProps } }
  slidesStore.updateElement({ id: handleElement.value.id, props })
  addHistorySnapshot()
}

const toggleOutline = (checked: boolean) => {
  if (!handleElement.value) return
  if (checked) {
    const _outline: PPTElementOutline = theme.value.outline
    slidesStore.updateElement({ id: handleElement.value.id, props: { outline: _outline } })
  }
  else {
    slidesStore.removeElementProps({ id: handleElement.value.id, propName: 'outline' })
  }
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.fixed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(Switch, {
              value: hasOutline.value,
              "onUpdate:value": _cache[0] || (_cache[0] = value => toggleOutline(value))
            }, null, 8, ["value"])
          ])
        ]))
      : _createCommentVNode("", true),
    (hasOutline.value && outline.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(Select, {
              style: {"width":"60%"},
              value: outline.value.style || '',
              "onUpdate:value": _cache[1] || (_cache[1] = value => updateOutline({ style: value as 'dashed' | 'solid' })),
              options: [
            { label: '实线边框', value: 'solid' },
            { label: '虚线边框', value: 'dashed' },
          ]
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(Popover, {
              trigger: "click",
              style: {"width":"60%"}
            }, {
              content: _withCtx(() => [
                _createVNode(ColorPicker, {
                  modelValue: outline.value.color,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = value => updateOutline({ color: value }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: outline.value.color || '#000'
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(NumberInput, {
              value: outline.value.width || 0,
              "onUpdate:value": _cache[3] || (_cache[3] = value => updateOutline({ width: value })),
              style: {"width":"60%"}
            }, null, 8, ["value"])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})